import React from 'react';
import Icon from '@ant-design/icons';

const StackedBarChartIcon = () => (
  <Icon
    component={({ ...rest }) => (
      <svg
        {...rest}
        width="1em"
        height="1em"
        viewBox="0 0 100 100"
        fill="currentColor"
      >
        <path d="m18,10l-8,0l0,80l80,0l0,-8l-72,0l0,-72z" />
        <path d="m26,74l64,0l0,-16l-64,0l0,16zm36.14451,-10.84393l22.84393,0l0,5.83237l-22.84393,0l0,-5.83237z" />
        <path d="m25.85549,50l64,0l0,-16l-64,0l0,16zm43.85549,-10.98844l14.84393,0l0.14451,6.12139l-14.84393,0l-0.14451,-6.12139z" />
        <path d="m25.86705,9.85549l0,16l64,0l0,-16l-64,0zm58.55492,10.55492l-42.2659,0l0,-5.54336l42.12139,0l0.14451,5.54336z" />
      </svg>
    )}
  />
);

export default StackedBarChartIcon;
